import { useMediaQuery } from '@mui/material';
import { DesktopProductCategoryHeader } from '@pages/ProductCategoryPage/Desktop/DesktopProductCategoryHeader';
import EmptyCategoryPage from '@pages/ProductCategoryPage/EmptyCategoryPage';
import { MobileProductCategoryHeader } from '@pages/ProductCategoryPage/Mobile/MobileProductCategoryHeader';
import type { ProductListAPIResponse } from '@partful/shared-types';
import { ContentPadding } from 'src/components/ContentPane';
import { device } from 'src/constants/mediaQueries';
import ProductList from '../product-list';

export type MessageType = 'error' | 'success';
export type DisplayMessageHandler = (title: string, message: string, messageType: MessageType) => void;

interface ProductCategoryPageProps {
  configurations: ProductListAPIResponse;
  decodedPathEnumeration: string;
}

export function Categories({ configurations, decodedPathEnumeration }: Readonly<ProductCategoryPageProps>) {
  const isMobile = useMediaQuery(device.mobileOrTablet);

  const filteredConfigurations = configurations
    ? configurations.filter(({ productCategories }) => productCategories?.includes(decodedPathEnumeration))
    : /* istanbul ignore next */ [];

  const showEmptyCategoryPage = !filteredConfigurations.length; // if configurations are found, show empty category page

  return (
    <ContentPadding>
      {isMobile ? (
        /* istanbul ignore next */
        <MobileProductCategoryHeader />
      ) : (
        <DesktopProductCategoryHeader decodedPathEnumeration={decodedPathEnumeration} />
      )}
      {showEmptyCategoryPage ? (
        /* istanbul ignore next */ <EmptyCategoryPage />
      ) : (
        <ProductList configurations={filteredConfigurations} isWithinCategory={Boolean(decodedPathEnumeration)} />
      )}
    </ContentPadding>
  );
}
